module.exports = __webpack_public_path__ + "img/race-based-housing.b52c385e.jpg";